

import { lazyInject } from '../../../../../services/inversify';
import * as React from 'react';
import { TriggerService } from '../../../../../core/trigger/trigger_service';
import btnSty from '../../../../../core/elements/buttons.less';
// import { StandorteFahrzeuge } from '../../../detail/StandorteFahrzeuge';
// import { StandorteMaschinen } from '../../../detail/StandorteMaschinen';
// import style from './../../Assistent.less';
import DialogWrapper2 from '../../../../../core/dialog/dialog_wrapper_v2';
// import { DateneingabeBetrieblicheDatenKennzahlen } from '../../../DateneingabeBetrieblicheDatenKennzahlen';
// import { WActionButton } from '../../../../../core/elements/WActionButton';
// import { EditBerater } from '../../../../../login/EditBerater';
import { EditOptionTabs } from '../../../../../login/EditOptionTabs';



export interface EinstellungBeraterButtonWrapperProps {
    data: any;
    onRoutingChange: (routing: any) => void;
}

export interface EinstellungBeraterButtonWrapperState {
    showDialog: boolean;
}

export class EinstellungBeraterButtonWrapper extends React.Component<EinstellungBeraterButtonWrapperProps, EinstellungBeraterButtonWrapperState> {

    constructor(props: any) {
        super(props);
        this.state = {
            showDialog: false,
        };
    }
    @lazyInject(TriggerService) private triggerService: TriggerService;

    render(): JSX.Element {

        return (
            <div>
                <button
                    className={btnSty.textButton}
                    onClick={() => this.setState({ showDialog: true })}
                >Auswahl/Freischaltung</button>
                {this.state.showDialog &&
                    <div>
                        <DialogWrapper2
                            width={-1}
                            onAfterClose={() => this.setState({ showDialog: undefined })}
                        >
                            <EditOptionTabs
                                data={this.props.data}
                                onRoutingChange={this.props.onRoutingChange}
                                initialTab={2}
                                onClose={() => this.setState({ showDialog: undefined })}
                            />
                        </DialogWrapper2>
                    </div>
                }
            </div>
        );
    }
}
